import { JmkwAviationConfig } from '@jeppesen-foreflight/jmkw-extensions';
import {
  IMPERIAL_DEFAULT,
  JmkwEnvironment
} from '@jeppesen-foreflight/jmkw-types';

export const aviation: Partial<JmkwAviationConfig> = {};

export const core: Partial<JmkwEnvironment> = {
  production: false,
  domain: 'https://jmkw-beta.jeppesen.com',
  base_href: '/v4/',
  telemetryKey: 'e1613ded-355c-4058-8669-2c1553caa676',
  logLevel: 'TRACE',
  persistView: false,
  unitConfigs: IMPERIAL_DEFAULT,
  themeConfig: {
    defaultTheme: 'default-light',
    // JMKW
    enabledThemes: [
      'default-light',
      'default-dark',
      'material-light',
      'material-dark',
      'fleet-insight'
      // 'christmas'
    ],
    // ESRI
    enabledBasemaps: [
      'jmkw-dark-basemap',
      'jmkw-light-basemap',
      'usgs-topo-basemap',
      'usgs-hydro-cached'
    ]
  }
};

export const environment: {
  core: Partial<JmkwEnvironment>;
  aviation: Partial<JmkwAviationConfig>;
} = {
  core,
  aviation
};
